import { render } from "./ProgramHorizontalCard.vue?vue&type=template&id=46eec816"
import script from "./ProgramHorizontalCard.vue?vue&type=script&lang=js"
export * from "./ProgramHorizontalCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/zaytoon-sudani-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__